export const TOOLTIP = {
  "Account Engagement Model": `<ul>
    <li style="line-height: 16px;">High Touch accounts are assigned to a named CSM and are managed with a frequent cadence and established proactive adoption methodology.</li>
    <li style="line-height: 16px;margin-top:8px">
    Scale accounts are assigned to a named CSM and are managed with a semi-regular light touch proactive engagement style.</li>
    <li style="line-height: 16px;margin-top:8px">
    Fed Longtail accounts are assigned to a named CSM or Team Alias and are managed with a reactive engagement style complemented with digital outreach.</li>
    <li style="line-height: 16px;margin-top:8px">
    Care Agent accounts are assigned to the Global Customer Care team and are primarily managed in a reactive style, but may be placed into a time-bound proactive campaign as necessary.</li>
    </ul>`,
  "CSE Activity Level Tooltips": `
  <div>
  <ul style="line-height: 16px;">
  The CSE Activity Level notes how engaged a CSE is with a customer.
  </ul>
    <ul style="padding-left: 16px; padding-top: 14px;">
    <li style="line-height: 16px;">
      Significant: The CSE is frequently engaged (e.g. on regular sync calls and/or email, Webex).
    </li>
    <li style="line-height: 16px;">
      Low: The CSE is occasionally engaged, on-and-off.
    </li>
    <li style="line-height: 16px;">
      None: The CSE is assigned to a customer account, but had no recent engagements.
    </li>
  </ul>
  </div>
  `,
};

export const invoiceTooltip = `
<ul style="margin-top:8px">
  <li style="line-height: 16px;">Offer Attribution: It is a set of end-to-end processes and capabilities (quoting, ordering, finance, reporting, and sales comp) to enable proper allocation of bookings, revenue, and associated compensation between business entities and service organizations</li>
  <li style="line-height: 16px;margin-top:8px">Adjustment = Discount</li>
</ul>
`;

export const healthTip = `<div>
<p>The Health Score listed here is: </p>
<p>1.the score of the primary Webex site URL under an account</p>
<p>2.Case when no sites associated to an account, then the score is associated to the Control Hub (CH) Organization ID linked to the account</p>
<p>3.Case when multiple Control Hub Organization ID's are linked to one account, then the score is of the CH Org ID that maps to a subscription having the highest Annual Recurring Revenue (ARR).</p>
<p>A primary site is the one with highest count of 'Active' users in last 30 days.</p>
<p>To view the score of other sites or CH Org IDs associated to the account, select 'Show All' under 'Site URLs' or 'Control Hub Organization ID' column or view them on the 'Details' page under 'Sites' section. The score is derived considering following contributory scores:</p>
<p>- Org Settings Score</p>
<p>- User Management Score</p>
<p>- Integration Score</p>
<p>
  - Meetings (Usage and Adoption Score, Join Meeting Time Score, In Meeting
  Score)
</p>
<p>- Rooms (Usage and Adoption Score, Quality Score)</p>
<p>- Messaging (Usage and Adoption Score)</p>
<p>- Calling (Usage and Adoption Score)</p>
</div>`;

export const customInvoiceARRTip = `<p style={{ lineHeight: "16px", fontSize: 12 }}>
            Sum of ARR of all the post offer attribution and post adjustment
            annual recurring revenue (ARR) of all products except Technical
            Support that are part of the Webex Suite offer under a given
            subscription + Video Device Bookings (Last 3 Years).${invoiceTooltip}
          </p>`;

export const suiteTip =
  "The Suite ARR section shows the revenue paid by the customer for Webex Suite broken down by Cloud, On-Prem.";
export const msgSuiteTip =
  "Meetings and Messaging Suite ARR attribution is determined by a calculation maintained by Cisco Finance. An attribution is a percentage of the total Suite purchase made by the customer that is allocated to the workload. This breakdown of revenue is internal only and may not align to CCW and/or external pricing.";

export const onPremCallingTip =
  "On-Prem Calling support typically includes moves, adds, changes, and break/fix. These requests are supported by Partners or the TAC organization.";
export const callingSuiteTip =
  "Calling Suite ARR attribution is determined by a calculation maintained by Cisco Finance. An attribution is a percentage of the total Suite purchase made by the customer that is allocated to the workload. This breakdown of revenue is internal only and may not align to CCW and/or external pricing.";
export const onPremCCTip =
  "On-Prem Contact Center is supported by the BU Contact Center Solution Assurance team. Please reach out to the Contact Center Solution Manager identified on the account where appropriate.";
export const notOnCloudVideoDeviceTip =
  "'Not On Cloud' devices are all units that have not been registered to the cloud or edge connect. There are no CS adoption motions associated with devices not on th cloud.";
